import { DialogDisclosure } from "@ariakit/react";
import { DialogTrigger } from "@indietabletop/appkit";
import { button } from "../../common/common.css.ts";
import { EditMode } from "../../engine/EditMode.ts";
import { CreateGitDialog } from "../GitFormDialog/GitFormDialog.tsx";
import { CreateVehicleDialog } from "../VehicleFormDialog/VehicleFormDialog.tsx";
import { CopySharedGangDialog } from "./CopySharedGangDialog.tsx";
import { StartCampaignDialog } from "./StartCampaignDialog.tsx";
import * as css from "./style.css.ts";
import { useGangContext } from "./useGang.ts";

export function GangActions() {
  const { gang, readOnly } = useGangContext();
  const { mode } = gang;

  if (readOnly) {
    return (
      <div className={css.common.actions}>
        <DialogTrigger>
          <CopySharedGangDialog />

          <DialogDisclosure
            className={button({
              size: "small",
              theme: "beige",
              maxInlineSize: "auto",
            })}
          >
            Copy shared gang
          </DialogDisclosure>
        </DialogTrigger>
      </div>
    );
  }

  const canAddModels = gang.can(EditMode.ADD, "models");

  return (
    <div className={css.common.actions}>
      {canAddModels && (
        <>
          <DialogTrigger>
            <CreateGitDialog />

            <DialogDisclosure className={css.gang.primaryButton}>
              Add Git
            </DialogDisclosure>
          </DialogTrigger>

          <DialogTrigger>
            <CreateVehicleDialog />

            <DialogDisclosure className={css.gang.primaryButton}>
              Add Vehicle
            </DialogDisclosure>
          </DialogTrigger>
        </>
      )}

      {!mode.isCampaignMode && (
        <DialogTrigger>
          <StartCampaignDialog />

          <DialogDisclosure
            className={
              canAddModels ? css.gang.secondaryButton : css.gang.primaryButton
            }
          >
            Start Campaign!
          </DialogDisclosure>
        </DialogTrigger>
      )}
    </div>
  );
}
